import { Pipe, PipeTransform } from '@angular/core';
import { PlaylistDTO } from '../models/view-models/playlist-models/playlist-dto.model';
import { SortEnum } from '../enums/playlist-sort.enum';

@Pipe({
  name: 'playlistSort'
})
export class PlaylistSortPipe implements PipeTransform {
  transform(playlists: any[] = [], sortBy: string, fieldName: string = 'PlaylistTitle'): PlaylistDTO[] {
    if (!playlists || !sortBy) {
      return playlists;
    }
    return playlists.sort((a: PlaylistDTO, b: PlaylistDTO): number => {
      let result = 0;

      switch (sortBy) {
        case SortEnum.SortByDateCreated:
          result = +new Date(b.DateCreated) - +new Date(a.DateCreated);
          break;

        case SortEnum.SortByPlaylistTitle:
          result = a[fieldName] > b[fieldName] ? 1 : -1;
          break;
      }

      return result;
    });
  }
}
